// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dq-a";
export var fulfillmentFormRail = "_dq-9";
export var headerTitleRow = "_dq-c";
export var orderDetailsWrapper = "_dq-7";
export var orderLinkTrigger = "_dq-2";
export var paymentInformationGrid = "_dq-h";
export var paymentSummaryColumn = "_dq-i";
export var shipmentContainer = "_dq-b";
export var shipmentDetailsMainPane = "_dq-8";
export var shipmentNavigationCard = "_dq-5";
export var shipmentNavigationRail = "_dq-3";
export var shipmentNavigationRailHeader = "_dq-4";
export var shipmentSummaryFact = "_dq-e";
export var shipmentSummaryGrid = "_dq-d";
export var shipmentSummaryMetadataRow = "_dq-f";
export var shipmentSummaryTags = "_dq-g";
export var shipmentWorkspace = "_dq-0";
export var shipmentWorkspaceContent = "_dq-6";
export var shipmentWorkspaceHeader = "_dq-1";